// Messaggi programmati (30-ott-2026): la scheda dell'annuncio con i messaggi che partono da soli
// per ogni prenotazione. Pannello: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Messaggi programmati",
    sub: "Ciò che riceve l'ospite, dalla prenotazione a dopo la partenza.",
    new: "Nuovo messaggio",
  },
  loadError: "Impossibile caricare i messaggi.",
  retry: "Riprova",
  cancel: "Annulla",
  noName: "Senza nome",
  tabs: { mensajes: "Messaggi", proximos: "Prossimi invii", historial: "Cronologia" },
  stages: { antes: "Prima dell'arrivo", durante: "Durante il soggiorno", despues: "Dopo la partenza" },
  when: {
    entrada: "check-in",
    salida: "check-out",
    sameDay: "Il giorno del {momento}, alle {hora}",
    before: "{n} giorno prima del {momento}, alle {hora} | {n} giorni prima del {momento}, alle {hora}",
    after: "{n} giorno dopo il {momento}, alle {hora} | {n} giorni dopo il {momento}, alle {hora}",
  },
  channels: { email: "E-mail", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Tutte", directa: "Dirette", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Altri canali" },
  status: {
    pendiente: "In corso",
    enviado: "Inviato",
    en_cola: "In attesa di accettazione",
    fallo: "Non inviato",
    sin_contacto: "Nessun recapito",
    cancelado: "Annullato",
  },
  errors: {
    canal_reserva_no_encontrada: "Il canale non ha trovato questa prenotazione. Potrebbe non esistere più o la sua chat potrebbe non essere disponibile.",
    canal_sin_permiso: "Il canale non ha autorizzato l'invio. Verifichi la connessione di questa struttura.",
    canal_no_responde: "Il canale non ha risposto in quel momento.",
    canal_rechazo: "Il canale non ha accettato il messaggio.",
    whatsapp_numero_invalido: "Il numero non è valido o non ha WhatsApp.",
    whatsapp_rechazo: "WhatsApp non ha accettato il messaggio.",
    correo_fallido: "L'e-mail non è stata recapitata.",
    envio_fallido: "Non è stato possibile completare l'invio.",
    envio_interrumpido: "L'invio si è interrotto prima di terminare.",
    sin_telefono: "La prenotazione non ha un telefono valido.",
    sin_correo: "La prenotazione non ha un'e-mail propria. Quella delle OTA è un alias.",
    sin_chat_ota: "La prenotazione non proviene da una OTA con chat.",
    mensaje_borrado: "Il messaggio è stato eliminato prima dell'invio.",
    mensaje_desactivado: "Il messaggio è stato disattivato prima dell'invio.",
    reserva_cancelada: "La prenotazione è stata annullata prima dell'invio.",
    alojamiento_no_existe: "La struttura non esiste più.",
    mensaje_vacio: "Il messaggio è risultato vuoto.",
    ya_no_tocaba: "Quando l'ospite ha accettato, non era più il caso di recapitarlo.",
  },
  unitScope: {
    sub: "Solo per {name}. Riceve anche quelli dell'annuncio, a meno che tu non li modifichi o li disattivi qui.",
    inherited: "Dall'annuncio",
    replaces: "Sostituisce quello dell'annuncio",
    removed: "Disattivato per questa unità",
    offInListing: "Disattivato nell'annuncio",
    differentIn: "Diverso in: {names}",
    customize: "Modifica solo per questa unità",
    turnOff: "Non inviare «{name}» per questa unità",
    confirmRestore: "Eliminare? Tornerà a partire quello dell'annuncio.",
    ownUnits: "Queste unità hanno anche messaggi propri: {names}. Si modificano da ogni unità.",
    replaceHint: "Stesso nome di uno dell'annuncio: per questa unità partirà questo al suo posto.",
  },
  clone: {
    button: "Clona",
    rowAction: "Clona su un'altra struttura o unità",
    titleAll: "Clona su altre strutture o unità",
    bring: "Importa",
    bringTitle: "Importa i messaggi da un'altra struttura o unità",
    bringNoun: "i suoi messaggi programmati",
    titleOne: "Clona «{name}»",
    subtitle: "Vengono copiati testo, canali, filtri e file. Un messaggio con lo stesso nome viene aggiornato; gli altri restano invariati. Quelli attivi inizieranno a partire all'ora locale di ogni struttura.",
    nounAll: "il messaggio programmato | i {n} messaggi programmati",
    nounOne: "il messaggio «{name}»",
    done: "Copiato su {n} alloggio: {nuevos} nuovi e {actualizados} aggiornati. | Copiato su {n} alloggi: {nuevos} nuovi e {actualizados} aggiornati.",
    skipped: {
      limite: "{names}: ha già il massimo di messaggi e «{msgs}» non è entrato.",
      archivo: "{names}: manca un file di «{msgs}». Caricalo di nuovo qui e clona ancora.",
      error: "{names}: impossibile copiare «{msgs}».",
    },
  },
  timeline: {
    booked: "Prenotazione confermata",
    bookedHint: "Se prenota quando il momento è già passato, quel messaggio non viene inviato.",
    checkin: "Giorno di arrivo",
    checkout: "Giorno di partenza",
    use: "Usa",
    add: "+ Aggiungi un messaggio qui",
    offset: {
      sameDay: "Quel giorno",
      before: "{n} giorno prima | {n} giorni prima",
      afterCheckin: "{n} giorno dopo | {n} giorni dopo",
      beforeCheckout: "{n} giorno prima di partire | {n} giorni prima di partire",
      after: "{n} giorno dopo | {n} giorni dopo",
    },
  },
  presets: {
    week: { name: "Manca una settimana", text: "Buongiorno {nombre}, manca poco al Suo soggiorno presso {alojamiento}. La aspettiamo il {entrada}. Se ha bisogno di qualcosa prima dell'arrivo, ci scriva." },
    three: { name: "Prepari il Suo arrivo", text: "Buongiorno {nombre}, tra 3 giorni La accogliamo presso {alojamiento}. Il check-in è a partire dalle {hora_entrada}. Qui trova tutto sul Suo soggiorno: {enlace_portal}" },
    arrival: { name: "Oggi è il Suo arrivo", text: "Buongiorno {nombre}, oggi La aspettiamo presso {alojamiento} a partire dalle {hora_entrada}. Buon viaggio!" },
    firstNight: { name: "Prima notte", text: "Buongiorno {nombre}, speriamo che si sia sistemato bene presso {alojamiento}. Va tutto bene? Se ha bisogno di qualcosa, risponda a questo messaggio." },
    lastDay: { name: "Giorno della partenza", text: "Buongiorno {nombre}, oggi termina il Suo soggiorno presso {alojamiento}. Ricordi che il check-out è entro le {hora_salida}. Grazie per aver scelto di soggiornare da noi." },
    after: { name: "Grazie della visita", text: "Buongiorno {nombre}, grazie per il Suo soggiorno presso {alojamiento}. Speriamo di rivederLa presto." },
  },
  row: {
    files: "{n} file | {n} file",
    sent: "{n} inviato | {n} inviati",
    queued: "{n} in attesa",
    failed: "{n} non partiti",
    duplicate: "Duplica",
    delete: "Elimina",
    confirmDelete: "Eliminare questo messaggio?",
    yesDelete: "Sì, elimina",
    copyOf: "Copia di {name}",
  },
  upcoming: {
    arrives: "Arriva il {fecha}",
    leaves: "Parte il {fecha}",
    note: "Ciò che partirà nei prossimi 30 giorni con le prenotazioni di oggi. Barrato: quella prenotazione non è raggiungibile da quel canale.",
    empty: "Nessun invio previsto nei prossimi 30 giorni.",
    when: "Quando",
    guest: "Ospite",
    message: "Messaggio",
    channels: "Canali",
    needsCheckin: "Solo se completa il check-in",
    noReach: "Nessun dato per questo canale",
  },
  history: {
    empty: "Non è ancora partito nessun messaggio.",
    when: "Data",
    result: "Esito",
    prev: "Precedente",
    next: "Successivo",
  },
  vars: {
    nombre: "Nome",
    alojamiento: "Alloggio",
    entrada: "Data di arrivo",
    salida: "Data di partenza",
    hora_entrada: "Ora di arrivo",
    hora_salida: "Ora di partenza",
    codigo: "Codice prenotazione",
    enlace_portal: "Link del portale",
    enlace_tienda: "Link del negozio",
  },
  form: {
    newTitle: "Nuovo messaggio",
    editTitle: "Modifica messaggio",
    name: "Nome interno",
    namePh: "Es.: Prepari il Suo arrivo",
    when: "Quando viene inviato",
    type: { antes: "Prima del", dia: "Lo stesso giorno del", despues: "Dopo il" },
    days: "Giorni",
    reference: "Riferimento",
    theDayOf: "Giorno del",
    anchor: { entrada: "Check-in", salida: "Check-out" },
    time: "Ora",
    timeIn: "ora di {zone}",
    timeEach: "all'ora locale di ogni struttura: {zones}",
    noZone: "{names}: senza un paese non conosciamo l'ora, quindi i messaggi non partiranno. Lo indichi nella posizione della struttura.",
    localTime: "ora dell'alloggio",
    duringHint: "Se il soggiorno è più breve e in quel giorno l'ospite non c'è più, non viene inviato.",
    channels: "Su quale canale",
    channelShort: { email: "Solo con e-mail propria", whatsapp: "Modello dopo 24 h", ota: "Chat della prenotazione" },
    previewShort: "Anteprima",
    previewFrom: "Messaggio da",
    channelHint: {
      email: "Solo per prenotazioni con e-mail propria. L'e-mail fornita dalle OTA è un alias, quindi lì non arriva.",
      whatsapp: "Se sono passate più di 24 h o non c'è una conversazione, inviamo il modello di contatto e il messaggio arriva quando l'ospite lo accetta. Con un numero falso non viene inviato nulla.",
      ota: "Tramite la chat dell'OTA, solo per prenotazioni di quel canale. I file vengono inviati come link.",
    },
    bookings: "Per quali prenotazioni",
    onlyCheckin: "Solo se ha già completato il check-in",
    message: "Messaggio",
    messagePh: "Scriva il messaggio che riceverà l'ospite",
    translate: "Traduci nelle altre lingue",
    translating: "Traduzione in corso…",
    translated: "Tradotto nelle altre lingue.",
    translatePartial: "{n} lingue non sono state tradotte. Le controlli.",
    storeHint: "Il negozio interno richiede un check-in completato; fino ad allora il link porta al portale dell'ospite, da cui si raggiunge. Con un negozio esterno porta direttamente lì.",
    fallbackHint: "Viene inviato nella lingua dell'ospite. Se quella lingua non è scritta, parte in spagnolo o nella prima disponibile.",
    subject: "Oggetto dell'e-mail (facoltativo)",
    subjectPh: "Se vuoto: Messaggio dal Suo alloggio",
    files: "Foto, video e documenti",
    addFile: "Aggiungi file",
    uploading: "Caricamento…",
    filesHint: "Foto JPG o PNG fino a {img} MB, PDF fino a {pdf} MB, XML fino a {xml} MB e video MP4 o 3GP (H.264) fino a {video} MB. WhatsApp non accetta XML come file: lì viene inviato come link. Via e-mail viene allegato.",
    fileTooBig: "«{name}» supera il limite di {max} MB.",
    uploadError: "Impossibile caricare il file.",
    active: "Attivo",
    inactive: "Disattivato",
    save: "Salva",
    saving: "Salvataggio…",
    saved: "Messaggio salvato.",
    saveError: "Impossibile salvare. Riprovi.",
    errName: "Dia un nome al messaggio.",
    errChannels: "Scelga almeno un canale di invio.",
    errTime: "Indichi l'ora di invio.",
    errText: "Scriva il messaggio in almeno una lingua.",
    preview: "Anteprima con dati di esempio",
    previewEmpty: "Qui vedrà il messaggio.",
  },
};
